var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import copy from 'clipboard-copy';
import cloneDeep from 'clone-deep';
import clsx from 'clsx';
import equal from 'deep-equal';
import _ from 'lodash';
import moment from 'moment';
import { parse, stringify } from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reset } from 'redux-form';
import { v4 } from 'uuid';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { apiCreateSlideClip, apiDeleteSlideClip, } from '../../../actions/AttachmentSlideActions';
import { apiAuthRoleSlide } from '../../../actions/AuthActions';
import { updateCanonical as updateCanonicalAction } from '../../../actions/CanonicalActions';
import { apiCreateClientSeminarDocumentPageView as apiCreateClientSeminarDocumentPageViewAction } from '../../../actions/ClientSeminarActions';
import { MODAL_TYPE_PDF_VIEW_IMAGE, MODAL_TYPE_SEND_PICKUP_COMPLETE, showModal, showModal as showModalAction, } from '../../../actions/ModalActions';
import { showNotification as showNotificationAction } from '../../../actions/NotificationActions';
import { API_GET_ONE_PROFILE_SUCCESS } from '../../../actions/ProfileActions';
import { apiGetListConsultantSearchMulti as apiGetListConsultantSearchMultiAction, apiUpdateConsultantSearchResultViewRequest, apiUpdateConsultantSearchViewRequest, } from '../../../actions/SearchConsultantActions';
import { solutionPickup } from '../../../actions/SearchSolutionActions';
import { CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE, CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE, getConsultantServiceTabs, getEnableConsultantPsSlideTypesList, getEnableConsultantSearchIdList, getEnableConsultantSlideSearchType, getEnableOrderTab, getEnablePage, getEnableSearchTab, getEnableSeminarOrderTab, getEnableSlideOrderTab, getEnablePsSlideOrderTab, isUseSlide, } from '../../../define/consts/consultant_search';
import { REGISTRATION_TYPE_CONSULTANT_SEARCH } from '../../../define/consts/registration';
import { hasSlideRole as hasSlideRoleCheck } from '../../../define/consts/role';
import { FORBIDDEN_SLIDE } from '../../../define/response';
import { wrapDispatch } from '../../../helpers/action';
import { isClient as isClientCheck, isClientPreStatus, isFreeProfessional as isFreeProfessionalCheck, isGuest as isGuestCheck, isProfessional as isProfessionalCheck, } from '../../../helpers/auth';
import { isNullOrUndefinedOrEmpty, isSupportFilter, sleep, } from '../../../helpers/common';
import { propArrayShape, propBool, propFunc, propShape, PropTypesAuthToken, propLocation, propHistory, } from '../../../helpers/custom-prop-types';
import { logError } from '../../../helpers/logger';
import { scrollToWithHeaderHeight } from '../../../helpers/ScrollUtils';
import { scrollToTopNoWait } from '../../../helpers/ui';
import { convertForCanonicalUrl } from '../../../helpers/url';
import GoogleAnalytics from '../../../vendor/GoogleAnalytics';
import Layout from '../../Layout';
import MediaQueryForConsultantSearchHoc from '../../Layout/MediaQuery/MediaQueryForConsultantSearchHoc';
import SendPickupCompleteModal from '../../Solutions/Search/Modal/SendPickupCompleteModal';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import FullScreenImageViewerModal from '../../Ui/Modal/FullScreenModal/ImageViewer/FullScreenImageViewerModal';
import RegistrationCompleteModal from '../../Ui/Modal/RegistrationCompleteModal';
import RegistrationCta from '../../Ui/Registration/RegistrationCta';
import CategoryHoc from '../../Ui/System/CategoryHoc';
import ConsultantSearchListFooter from '../Parts/Footer';
import ConsultantSearchHeader from '../Parts/Header';
import ConsultantSearchListBody from '../Parts/ListBody/ConsultantSearchListBody';
import ConsultantSearchListBodySlideOne from '../Parts/ListBody/ConsultantSearchListBodySlideOne';
class ConsultantSearchList extends Component {
    constructor(props) {
        super(props);
        /**
         * canonical タグ更新
         * @param {{string: keyword, string: search}} query canonical のURLに設定する query
         */
        this.updateCanonicalTag = ({ keyword, search }) => {
            const { updateCanonical } = this.props;
            const url = window.location.href;
            const query = { keyword, search };
            const canonicalUrl = convertForCanonicalUrl(url, query);
            updateCanonical(canonicalUrl);
        };
        /**
         * 更新する検索条件のstateからurlと履歴を更新する
         * @param updateValue
         */
        this.setHistoryFromUpdateState = (updateValue) => {
            const { history, location } = this.props;
            const { industries, isAdmin, isClient, keyword, order, psSlideOrder, psSlidePage, psSlideTypes, search, searchPage, seminarOrder, seminarPage, seminarThemes, seminarTypes, servicePage, showSlidePage, slideKinds, slideOrder, slidePage, slideThemes, slideTypes, } = this.state;
            const currentValue = _.pick(this.state, Object.keys(updateValue));
            if (equal(currentValue, updateValue)) {
                return false;
            }
            const omitKeys = [
                'searchFrom',
                'consultantSearchHistoryProfessionalId',
                'consultantSearchHistoryServiceId',
            ];
            if (!isUseSlide(isAdmin)) {
                omitKeys.concat([
                    'slideTypes',
                    'slideThemes',
                    'slideKinds',
                    'slideOrder',
                    'slidePage',
                    'showSlidePage',
                ]);
            }
            if (!isClient) {
                omitKeys.concat(['psSlideTypes', 'psSlideOrder', 'psSlidePage']);
            }
            const currentQuery = _.omit(parse(location.search), omitKeys);
            const slideObject = isUseSlide(isAdmin)
                ? {
                    showSlidePage,
                    slideKinds,
                    slideOrder,
                    slidePage,
                    slideThemes,
                    slideTypes,
                }
                : {};
            const psSlideObject = isClient
                ? {
                    psSlideOrder,
                    psSlidePage,
                    psSlideTypes,
                }
                : {};
            const queryObject = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, currentQuery), { industries,
                keyword,
                order,
                search,
                searchPage,
                seminarOrder,
                seminarPage,
                seminarThemes,
                seminarTypes,
                servicePage }), slideObject), psSlideObject), updateValue);
            [
                'industries',
                'seminarTypes',
                'seminarThemes',
                'slideTypes',
                'slideThemes',
                'slideKinds',
                'psSlideTypes',
            ].forEach((key) => {
                if (queryObject[key]) {
                    queryObject[key] = JSON.stringify(queryObject[key]);
                }
            });
            const newQuery = stringify(queryObject);
            history.push(`${location.pathname}?${newQuery}`);
            return true;
        };
        /**
         * 表示上限を取得
         * @returns {number}
         */
        this.getPerPage = () => {
            const { isClient, search } = this.state;
            let perPage = null;
            switch (search) {
                case 'slide':
                    perPage = 12;
                    break;
                case 'psSlide':
                    perPage = 6;
                    break;
                case 'seminar':
                    perPage = 10;
                    break;
                default:
                    perPage = isClient ? 8 : 3;
            }
            return perPage;
        };
        /**
         * urlのquery stringから検索用項目のstateを取得
         * @param props
         * @param isAdmin
         * @param tabs
         * @returns {*}
         */
        this.getQueryStateFromHistory = (props, isAdmin, tabs) => {
            const { auth, location, slideTypes } = props;
            const { industries: rawIndustries, keyword, order: rawOrder, psSlideOrder: rawPsSlideOrder, psSlidePage: rawPsSlidePage, psSlideSearchType: rawPsSlideSearchType, psSlideTypes: rawPsTypes, search: rawSearch, searchPage: rawSearchPage, seminarOrder: rawSeminarOrder, seminarPage: rawSeminarPage, seminarThemes: rawSeminarThemes, seminarTypes: rawSeminarTypes, servicePage: rawServicePage, showSlidePage: rawShowSlidePage, slideKinds: rawKinds, slideOrder: rawSlideOrder, slidePage: rawSlidePage, slideSearchType: rawSlideSearchType, slideThemes: rawThemes, slideTypes: rawTypes, } = parse(location.search);
            const isClient = isClientCheck(auth);
            const isProfessional = isProfessionalCheck(auth);
            const setKeyword = isNullOrUndefinedOrEmpty(keyword) ? '' : keyword;
            if (!isClient) {
                return {
                    industries: [],
                    inputIndustries: [],
                    inputKeyword: setKeyword,
                    inputPsSlideTypes: [],
                    inputSeminarThemes: [],
                    inputSlideKinds: [],
                    inputSlideThemes: [],
                    inputSlideTypes: [],
                    keyword: setKeyword,
                    order: getEnableOrderTab(rawOrder),
                    psSlideOrder: '',
                    psSlidePage: 1,
                    psSlideSearchType: CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE,
                    psSlideTypes: [],
                    rawShowSlidePage: null,
                    search: isProfessional ? 'search' : getEnableSearchTab(tabs, rawSearch),
                    searchPage: 1,
                    seminarOrder: '',
                    seminarPage: 1,
                    seminarThemes: [],
                    seminarTypes: [],
                    servicePage: 1,
                    slideKinds: [],
                    slideOrder: 'desc_text_count',
                    slidePage: 1,
                    slideSearchType: CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE,
                    slideThemes: [],
                    slideTypes: [],
                };
            }
            const intShowSlidePage = parseInt(rawShowSlidePage, 10);
            return {
                industries: getEnableConsultantSearchIdList(rawIndustries),
                inputIndustries: getEnableConsultantSearchIdList(rawIndustries),
                inputKeyword: setKeyword,
                inputPsSlideTypes: getEnableConsultantPsSlideTypesList(rawPsTypes, slideTypes),
                inputSeminarThemes: getEnableConsultantSearchIdList(rawSeminarThemes),
                inputSlideKinds: getEnableConsultantSearchIdList(rawKinds),
                inputSlideThemes: getEnableConsultantSearchIdList(rawThemes),
                inputSlideTypes: getEnableConsultantSearchIdList(rawTypes),
                keyword: setKeyword,
                order: getEnableOrderTab(rawOrder),
                psSlideOrder: getEnablePsSlideOrderTab(rawPsSlideOrder),
                psSlidePage: getEnablePage(rawPsSlidePage),
                psSlideSearchType: getEnableConsultantSlideSearchType(rawPsSlideSearchType),
                psSlideTypes: getEnableConsultantPsSlideTypesList(rawPsTypes, slideTypes),
                search: getEnableSearchTab(tabs, rawSearch),
                searchPage: getEnablePage(rawSearchPage),
                seminarOrder: getEnableSeminarOrderTab(rawSeminarOrder),
                seminarPage: getEnablePage(rawSeminarPage),
                seminarThemes: getEnableConsultantSearchIdList(rawSeminarThemes),
                seminarTypes: getEnableConsultantSearchIdList(rawSeminarTypes, false),
                servicePage: getEnablePage(rawServicePage),
                showSlidePage: Number.isNaN(intShowSlidePage) ? null : intShowSlidePage,
                slideKinds: getEnableConsultantSearchIdList(rawKinds),
                slideOrder: getEnableSlideOrderTab(rawSlideOrder),
                slidePage: getEnablePage(rawSlidePage),
                slideSearchType: getEnableConsultantSlideSearchType(rawSlideSearchType),
                slideThemes: getEnableConsultantSearchIdList(rawThemes),
                slideTypes: getEnableConsultantSearchIdList(rawTypes),
            };
        };
        /**
         * 安全にstateを更新
         * @param state
         */
        this.safeSetState = (state) => {
            if (!this.isUnmount) {
                this.setState(state);
            }
        };
        /**
         * 各タブのロジックごとに使用するパラメータの取得
         * @param state
         * @param search
         * @param rawOptions
         * @returns {*}
         */
        this.getViewParam = (state, search, rawOptions = {}) => {
            const { hasSlideRole, industries, isClient, order, professionalPaging, psSlideOrder, psSlidePage, psSlidePaging, psSlideTypes, searchPage, seminarOrder, seminarPage, seminarPaging, seminarThemes, seminarTypes, servicePage, slideKinds: kinds, slideOrder, slidePage, slidePaging, slideThemes: themes, slideTypes: types, solutionPaging, } = state;
            const professionalPageData = professionalPaging.pages[searchPage] || {};
            const solutionPageData = solutionPaging.pages[servicePage] || {};
            const seminarPageData = seminarPaging.pages[seminarPage] || {};
            const slidePageData = slidePaging.pages[slidePage] || {};
            const psSlidePageData = psSlidePaging.pages[psSlidePage] || {};
            const options = rawOptions;
            if (!options.searchFrom) {
                options.searchFrom = window.location.pathname;
            }
            const getNoResult = (checkData) => !!checkData.initialLoaded && (checkData.list || []).length === 0;
            switch (search) {
                case 'search': {
                    return {
                        historyId: professionalPaging.historyId,
                        initialLoaded: !!professionalPageData.initialLoaded,
                        isNoResult: getNoResult(professionalPageData),
                        order,
                        pageName: 'searchPage',
                        pageNo: searchPage,
                        params: Object.assign({ industries }, options),
                        stateName: 'professionalPaging',
                        total: professionalPaging.total,
                    };
                }
                case 'service': {
                    return {
                        historyId: solutionPaging.historyId,
                        initialLoaded: !!solutionPageData.initialLoaded,
                        isNoResult: getNoResult(solutionPageData),
                        order,
                        pageName: 'servicePage',
                        pageNo: servicePage,
                        params: Object.assign({ industries }, options),
                        stateName: 'solutionPaging',
                        total: solutionPaging.total,
                    };
                }
                case 'seminar': {
                    return {
                        historyId: seminarPaging.historyId,
                        initialLoaded: !!seminarPageData.initialLoaded,
                        isNoResult: getNoResult(seminarPageData),
                        order: seminarOrder,
                        pageName: 'seminarPage',
                        pageNo: seminarPage,
                        params: Object.assign({ themes: seminarThemes, types: seminarTypes }, options),
                        stateName: 'seminarPaging',
                        total: seminarPaging.total,
                    };
                }
                case 'slide': {
                    return hasSlideRole
                        ? {
                            historyId: slidePaging.historyId,
                            initialLoaded: !!slidePageData.initialLoaded,
                            isNoResult: getNoResult(slidePageData),
                            order: slideOrder,
                            pageName: 'slidePage',
                            pageNo: slidePage,
                            params: Object.assign({ kinds: kinds.map((kind) => ({
                                    1: 'rfp',
                                    2: 'offer',
                                    3: 'solution',
                                })[kind]), themes,
                                types }, options),
                            stateName: 'slidePaging',
                            total: slidePaging.total,
                        }
                        : {};
                }
                case 'psSlide': {
                    return isClient
                        ? {
                            historyId: psSlidePaging.historyId,
                            initialLoaded: !!psSlidePageData.initialLoaded,
                            isNoResult: getNoResult(psSlidePageData),
                            order: psSlideOrder,
                            pageName: 'psSlidePage',
                            pageNo: psSlidePage,
                            params: Object.assign({ types: psSlideTypes }, options),
                            stateName: 'psSlidePaging',
                            total: psSlidePaging.total,
                        }
                        : {};
                }
                default: {
                    return {};
                }
            }
        };
        /**
         * ヘッダ用件数の取得
         * @param state
         * @returns {*}
         */
        this.getViewTotals = (state) => {
            const { professionalPaging, psSlidePaging, seminarPaging, slidePaging, solutionPaging, } = state;
            return {
                psSlide: psSlidePaging.total,
                search: professionalPaging.total,
                seminar: seminarPaging.total,
                service: solutionPaging.total,
                slide: slidePaging.total,
            };
        };
        /**
         * 初期読み込みの実行
         * @param props
         * @param state
         * @param options
         * @param baseId
         * @returns {Promise<void>}
         */
        this.loadInitialData = (props, state, options = {}, baseId = null) => __awaiter(this, void 0, void 0, function* () {
            const { keyword } = state;
            if (isNullOrUndefinedOrEmpty(keyword)) {
                return;
            }
            const updateState = {
                professionalPaging: cloneDeep(this.initialPageState),
                psSlidePaging: cloneDeep(this.initialPageState),
                seminarPaging: cloneDeep(this.initialPageState),
                slidePaging: cloneDeep(this.initialPageState),
                solutionPaging: cloneDeep(this.initialPageState),
            };
            const newState = Object.assign(Object.assign({}, state), updateState);
            // 既存データをリセット
            this.safeSetState(updateState);
            // データ取得の実行
            yield this.loadData(newState, this.getSearches(), options, baseId);
        });
        // array or objectでパラメータを渡す
        /**
         * 指定のページのデータ読み込みの実行
         * @param state
         * @param searches
         * @param options
         * @param baseId
         * @returns {Promise<void>}
         */
        this.loadData = (state, searches, options = {}, baseId = null) => __awaiter(this, void 0, void 0, function* () {
            const { keyword, search } = state;
            const params = {};
            const viewParams = {};
            searches.forEach((v) => {
                const key = this.parseSearchValue(v, state);
                viewParams[key] = this.getViewParam(state, v, options);
                const { order, pageNo, params: rawParams, stateName } = viewParams[key];
                this.updatePage(stateName, state[stateName], pageNo, { loading: true });
                params[key] = Object.assign({ keyword,
                    order, page: pageNo }, rawParams);
            });
            params.search = this.parseSearchValue(search, state);
            if (baseId) {
                params.baseId = baseId;
            }
            const uuid = v4();
            this.apiId = uuid;
            try {
                const { apiGetListConsultantSearchMulti } = this.props;
                const { payload } = yield apiGetListConsultantSearchMulti(params);
                if (this.apiId === uuid) {
                    yield scrollToTopNoWait();
                    searches.forEach((v) => {
                        const { historyId, list: rawList, maxScore, total, } = payload[this.parseSearchValue(v, state, true)];
                        const list = rawList || [];
                        const { pageNo, stateName } = viewParams[this.parseSearchValue(v, state)];
                        if (search === 'slide') {
                            // ページをまたぐお気に入り状態の更新
                            const newMaps = {};
                            list.forEach(({ pages = [] }) => {
                                pages.forEach((page) => {
                                    newMaps[page.id] = page.hasFavorite;
                                });
                            });
                            this.safeSetState((prevState) => ({
                                slideFavoriteMap: Object.assign(Object.assign({}, prevState.slideFavoriteMap), newMaps),
                            }));
                        }
                        this.updatePage(stateName, state[stateName], pageNo, {
                            initialLoaded: true,
                            list,
                            loading: false,
                        }, { historyId, maxScore, total });
                    });
                }
            }
            catch (e) {
                // アラートを表示しよう
                logError(e);
                if (search === 'slide' && e.code === FORBIDDEN_SLIDE) {
                    this.safeSetState({ isShowLoginModal: true });
                }
            }
        });
        /**
         * pageのstateの更新
         * @param pageName
         * @param pageData
         * @param pageNo
         * @param pageObject
         * @param mergeObject
         */
        this.updatePage = (pageName, pageData, pageNo, pageObject, mergeObject = {}) => {
            const currentPage = pageData.pages[pageNo] || {};
            const updateObject = Object.assign(Object.assign({}, pageData), { pages: Object.assign(Object.assign({}, pageData.pages), { [pageNo]: Object.assign(Object.assign({}, currentPage), pageObject) }) });
            if (mergeObject) {
                Object.keys(mergeObject).forEach((key) => {
                    updateObject[key] = mergeObject[key];
                });
            }
            this.safeSetState({ [pageName]: updateObject });
        };
        /**
         * ユーザーのログイン状態の取得
         * @param auth
         * @param profile
         * @returns {{isGuest: *, isPre: boolean, isProfessional: *, isClient: *, isAdmin: boolean}}
         */
        this.loadUserState = (auth, profile) => ({
            hasSlideRole: hasSlideRoleCheck(profile, moment()),
            isAdmin: !!profile.isAdmin,
            isClient: isClientCheck(auth),
            isGuest: isGuestCheck(auth),
            isPre: isClientPreStatus(profile),
            isProfessional: isProfessionalCheck(auth) || isFreeProfessionalCheck(auth),
        });
        /**
         * 検索キーワードを入力した際のイベント
         * @param inputKeyword
         */
        this.onChangeKeyword = (inputKeyword) => {
            this.safeSetState({ inputKeyword });
        };
        /**
         * 検索キーワードを変更して確定した際のイベント
         */
        this.onChangeKeywordSubmit = (e) => {
            e.preventDefault();
            const { inputKeyword: keyword } = this.state;
            if (isNullOrUndefinedOrEmpty(keyword)) {
                return;
            }
            const updateValue = this.getReloadFilterParams();
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                // データの読み込み直し
                this.loadInitialData(this.props, Object.assign(Object.assign({}, this.state), updateValue)).then();
            }
        };
        /**
         * 検索対象を取得する関数
         * @returns {string[]}
         */
        this.getSearches = () => {
            const { hasSlideRole, isClient } = this.state;
            const searches = ['search', 'service', 'seminar'];
            if (hasSlideRole) {
                searches.push('slide');
            }
            if (isClient) {
                searches.push('psSlide');
            }
            return searches;
        };
        /**
         * searchの文字列をAPIのキーと一致させるための関数
         * @param search
         * @param state
         * @param isCamelCase
         * @returns {string}
         */
        this.parseSearchValue = (search, state, isCamelCase = false) => {
            const { psSlideSearchType, slideSearchType } = state;
            let value = '';
            switch (search) {
                case 'search':
                    value = 'professional';
                    break;
                case 'service':
                    value = 'solutions';
                    break;
                case 'seminar':
                    value = 'seminar';
                    break;
                case 'slide':
                    value =
                        slideSearchType === CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE
                            ? 'slide_page'
                            : 'slide';
                    break;
                case 'psSlide':
                    value =
                        psSlideSearchType === CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE
                            ? 'ps_slide_page'
                            : 'ps_slide';
                    break;
                default:
                    break;
            }
            if (isCamelCase) {
                return value.replace(/_./g, (v) => v.charAt(1).toUpperCase());
            }
            return value;
        };
        /**
         * tabを変更した際のイベント
         * @param e
         */
        this.onChangeSearch = (e) => __awaiter(this, void 0, void 0, function* () {
            const { updateConsultantSearchViewRequest } = this.props;
            const search = e.currentTarget.value;
            const { historyId } = this.getViewParam(this.state, search, {});
            yield Promise.all([
                this.onChangeSearchMain(search),
                (() => __awaiter(this, void 0, void 0, function* () {
                    if (!historyId) {
                        return;
                    }
                    yield updateConsultantSearchViewRequest(historyId);
                }))(),
            ]);
        });
        /**
         * tabを変更した際のイベントの実処理部
         * @param search
         */
        this.onChangeSearchMain = (search) => __awaiter(this, void 0, void 0, function* () {
            const { hasSlideRole } = this.state;
            this.safeSetState({ search });
            this.setHistoryFromUpdateState({ search });
            const newState = Object.assign(Object.assign({}, this.state), { search });
            const { pageNo, stateName } = this.getViewParam(newState, search);
            const initialLoaded = !!_.get(newState, `${stateName}.pages.${pageNo}.initialLoaded`);
            if (search === 'slide' && !hasSlideRole) {
                this.safeSetState({ isShowLoginModal: true });
            }
            if (!initialLoaded) {
                yield this.loadData(newState, this.getSearches());
            }
        });
        /**
         * 並び順を変更した際のイベント
         * @param value 選択された値
         * @param name 対象のキー
         */
        this.onChangeOrder = (value, name) => {
            const updateValue = Object.assign(Object.assign({}, this.getReloadFilterParams()), { [name]: value });
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                // データの読み込み直し
                this.loadInitialData(this.props, Object.assign(Object.assign({}, this.state), updateValue)).then();
            }
        };
        /**
         * スライド以外の並び順を変更した際のイベント
         * @param e
         */
        this.onChangeNormalOrder = (e) => {
            this.onChangeOrder(e, 'order');
        };
        /**
         * セミナーの並び順を変更した際のイベント
         * @param e
         */
        this.onChangeSeminarOrder = (e) => {
            this.onChangeOrder(e, 'seminarOrder');
        };
        /**
         * スライドの並び順を変更した際のイベント
         * @param e
         */
        this.onChangeSlideOrder = (e) => {
            this.onChangeOrder(e, 'slideOrder');
        };
        /**
         * PROFFIT SEARCH スライドの並び順を変更した際のイベント
         * @param e
         */
        this.onChangePsSlideOrder = (e) => {
            this.onChangeOrder(e, 'psSlideOrder');
        };
        /**
         * フィルター表示状態の切り替え
         */
        this.toggleFilter = () => {
            const { isShowFilter } = this.state;
            this.setState({ isShowFilter: !isShowFilter });
        };
        /**
         * 入力状態が変更されたら
         * @param e
         */
        this.onChangeInputFilter = (e) => {
            const { checked, name, value } = e.currentTarget;
            const keyName = {
                industry: 'inputIndustries',
                psSlideType: 'inputPsSlideTypes',
                seminarTheme: 'inputSeminarThemes',
                slideKind: 'inputSlideKinds',
                slideTheme: 'inputSlideThemes',
                slideType: 'inputSlideTypes',
            }[name];
            const { [keyName]: stateValues } = this.state;
            const intValue = parseInt(value, 10);
            const newStateValues = stateValues.filter((v) => v !== intValue);
            if (checked) {
                newStateValues.push(intValue);
            }
            this.safeSetState({ [keyName]: [...newStateValues] });
        };
        /**
         * セミナーのタイプの入力状態が変更された際のイベント
         * @param e
         */
        this.onChangeSeminarTypes = (e) => {
            const { checked, value } = e.currentTarget;
            const { seminarTypes } = this.state;
            const newValues = seminarTypes.filter((v) => v !== value);
            if (checked) {
                newValues.push(value);
            }
            const updateValue = Object.assign(Object.assign({}, this.getReloadFilterParams()), { seminarTypes: newValues });
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                // データの読み込み直し
                this.loadInitialData(this.props, Object.assign(Object.assign({}, this.state), updateValue)).then();
            }
        };
        /**
         * 絞り込みの実行
         */
        this.onChangeFilter = () => {
            const updateValue = this.getReloadFilterParams();
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                // データの読み込み直し
                this.loadInitialData(this.props, Object.assign(Object.assign({}, this.state), updateValue)).then();
            }
        };
        /**
         * スライド検索の変更
         */
        this.onChangeSlideSearchType = (stateName, slideSearchTypeState) => __awaiter(this, void 0, void 0, function* () {
            const updateValue = Object.assign(Object.assign({}, this.getReloadFilterParams()), { [stateName]: slideSearchTypeState === CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE
                    ? CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_PAGE
                    : CONSULTANT_SEARCH_SLIDE_SEARCH_TYPE_SLIDE });
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                // データの読み込み直し
                yield this.loadInitialData(this.props, Object.assign(Object.assign({}, this.state), updateValue));
            }
        });
        /**
         * PROFFIT スライド検索の変更
         */
        this.onChangeProffitSlideSearchType = () => {
            const { slideSearchType } = this.state;
            this.onChangeSlideSearchType('slideSearchType', slideSearchType);
        };
        /**
         * PROFFIT SEARCH スライド検索の変更
         */
        this.onChangePsSlideSearchType = () => {
            const { psSlideSearchType } = this.state;
            this.onChangeSlideSearchType('psSlideSearchType', psSlideSearchType);
        };
        /**
         * 再検索する際に使用するパラメータ一式の取得
         * @returns {*}
         */
        this.getReloadFilterParams = () => {
            const { inputIndustries: industries, inputKeyword: keyword, inputPsSlideTypes: psSlideTypes, inputSeminarThemes: seminarThemes, inputSlideKinds: slideKinds, inputSlideThemes: slideThemes, inputSlideTypes: slideTypes, isAdmin, isClient, } = this.state;
            const slideValue = isUseSlide(isAdmin)
                ? {
                    showSlidePage: null,
                    slideKinds,
                    slidePage: 1,
                    slideThemes,
                    slideTypes,
                }
                : {};
            const psSlideValue = isClient
                ? {
                    psSlidePage: 1,
                    psSlideTypes,
                }
                : {};
            return Object.assign(Object.assign({ industries,
                keyword, searchPage: 1, seminarPage: 1, seminarThemes, servicePage: 1 }, slideValue), psSlideValue);
        };
        /**
         * 各リンクでのボタンのイベント
         */
        this.onClickForLinkEvent = (e) => {
            const { updateConsultantSearchViewRequestResult } = this.props;
            const { isGuest, isPre, search } = this.state;
            const { result_id: resultId, text } = e.currentTarget.dataset;
            const { historyId } = this.getViewParam(this.state, search);
            // 検索ログに保存させたいメタ情報を設定
            const params = text ? { text } : {};
            // アクセスの履歴の付与
            updateConsultantSearchViewRequestResult(historyId, resultId, params);
            if (isGuest && search === 'service') {
                // 事例をゲストの時にリンクを押した場合
                e.preventDefault();
                GoogleAnalytics.sendClickEvent('search_registration', 'search_consultant_detailclick', '');
                this.scrollToRegistrationForm();
            }
            else if (isPre) {
                this.safeSetState({ isShowPreAlert: true });
            }
        };
        this.scrollToRegistrationForm = () => {
            const { isMd } = this.props;
            scrollToWithHeaderHeight('consultant_search_registration_form', {
                offset: isMd ? -160 : -70,
            });
        };
        /**
         * ゲスト会員用の登録完了モーダルを表示する
         */
        this.showRegistrationCompleteModal = () => {
            this.safeSetState({ isShowRegistrationCompleteModal: true });
        };
        /**
         * ゲスト会員用の登録完了モーダルを非表示にする
         */
        this.hideRegistrationCompleteModal = () => {
            this.safeSetState({ isShowRegistrationCompleteModal: false });
        };
        /**
         * ゲスト会員の登録後、フォームを非表示にしつつ完了モーダルを表示する
         */
        this.onSubmitAfterRegistration = () => {
            this.safeSetState({ isShowRegistrationForm: false });
            this.showRegistrationCompleteModal();
        };
        /**
         * ログインモーダルを閉じるイベント
         */
        this.onClickLoginClose = () => {
            this.safeSetState({ isShowLoginModal: false });
        };
        /**
         * プレ会員時のクリックイベント
         */
        this.onClickExaminationAlert = () => {
            this.safeSetState({ isShowPreAlert: false });
        };
        /**
         * ページネーションのクリック
         */
        this.onClickPage = () => {
            const { isClient, search } = this.state;
            // ゲストかつセミナー以外である
            if (!isClient && search !== 'seminar') {
                // 登録フォームまでスクロールさせる
                ;
                (() => __awaiter(this, void 0, void 0, function* () {
                    yield sleep(0.1);
                    this.scrollToRegistrationForm();
                }))();
                // falseを返して以降の処理（ページネーション）をキャンセルする
                return false;
            }
            return undefined;
        };
        /**
         * ページネーションの実行
         * @param page ページ
         */
        this.onChangePage = (page) => __awaiter(this, void 0, void 0, function* () {
            const { search } = this.state;
            const { pageName } = this.getViewParam(this.state, search);
            const updateValue = { [pageName]: page + 1 };
            const updateState = Object.assign(Object.assign({}, this.state), updateValue);
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.safeSetState(updateValue);
                yield this.loadData(updateState, [search]);
            }
        });
        /**
         * スライドのクリック
         * @param e
         */
        this.onClickSlide = (e) => {
            const { value } = e.currentTarget.attributes['data-value'];
            const updateValue = { showSlidePage: parseInt(value, 10) };
            this.safeSetState(updateValue);
            this.setHistoryFromUpdateState(Object.assign(Object.assign({}, this.getReloadFilterParams()), updateValue));
        };
        /**
         * スライドのお気に入りの更新
         * @param e イベント
         */
        this.onClickSlideClip = (e) => {
            // リンクイベントを無効化
            e.stopPropagation();
            e.preventDefault();
            const { value: id } = e.currentTarget;
            const { createSlideClip, deleteSlideClip } = this.props;
            const { slideFavoriteMap } = this.state;
            // 現在の選択状態
            const isSelected = slideFavoriteMap[id];
            this.safeSetState({
                slideFavoriteMap: Object.assign(Object.assign({}, slideFavoriteMap), { 
                    // 選択状態を反転
                    [id]: !isSelected }),
            });
            if (isSelected) {
                deleteSlideClip(id);
            }
            else {
                createSlideClip(id);
            }
        };
        /**
         * pickupの実行
         * @param values
         * @param dispatch
         * @param formProps
         * @returns {Promise<void>}
         */
        this.sendPickup = (values, dispatch, formProps) => __awaiter(this, void 0, void 0, function* () {
            const { resetPickup, sendPickup, showSendPickupCompleteModal } = this.props;
            yield sendPickup(values);
            resetPickup(formProps.form);
            showSendPickupCompleteModal();
        });
        this.onClickProjectCountLink = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const { keyword } = e.currentTarget.dataset;
            const search = 'service';
            const { pageName } = this.getViewParam(this.state, search);
            const updateValue = {
                keyword,
                [pageName]: 1,
                search,
            };
            const newState = Object.assign(Object.assign({}, this.state), updateValue);
            this.safeSetState(updateValue);
            const isUpdate = this.setHistoryFromUpdateState(updateValue);
            if (isUpdate) {
                this.loadData(newState, this.getSearches()).then();
            }
        };
        /**
         * コピーの実行
         * @param e
         * @return {Promise<void>}
         */
        this.onClickCopy = (e) => __awaiter(this, void 0, void 0, function* () {
            const { value } = e.currentTarget;
            const { showNotification } = this.props;
            const url = [
                `${window.location.protocol}//${window.location.host}`,
                'consultant',
                'slide',
                'page',
                value,
            ].join('/');
            yield Promise.all([copy(url), showNotification('コピーしました。')]);
        });
        /**
         * slideをクリックし、詳細ページを開いた場合のイベント
         * @param e
         */
        this.onClickSlideShow = (e) => {
            const { showPdfModal } = this.props;
            const { search, slidePage, slidePaging } = this.state;
            const id = parseInt(e.currentTarget.value, 10);
            this.getViewParam(this.state, search);
            const model = slidePaging.pages[slidePage].list.find((findModel) => findModel.id === id);
            if (model) {
                const initialSlide = model.pages.findIndex((pageModel) => pageModel.id === model.slidePageId);
                showPdfModal(model.pages, Math.max(initialSlide, 0));
            }
        };
        /**
         * セミナー資料表示ボタンをクリックした際のイベント
         * @type {(function())|*}
         */
        this.onClickSeminarDocumentLink = (e) => {
            var _a;
            const { seminarPage, seminarPaging } = this.state;
            const seminarPageData = seminarPaging.pages[seminarPage];
            const { value } = e.currentTarget;
            const id = parseInt(value, 10);
            // 検索結果から該当するセミナーを取得する
            const { information } = seminarPageData.list.find((v) => v.id === id) || {};
            // 分割画像が存在する場合、モーダル表示用に画像をセット
            const seminarImages = ((_a = information === null || information === void 0 ? void 0 : information.images) === null || _a === void 0 ? void 0 : _a.map((v) => v.path)) || [];
            // モーダル表示
            this.safeSetState({
                documentModalImages: seminarImages,
                isShowDocumentModal: true,
                seminarIdDisplayedDocument: id,
            });
        };
        /**
         * 資料表示モーダルを閉じるイベント
         * @type {(function())|*}
         */
        this.onClickDocumentModalClose = () => {
            this.safeSetState({ isShowDocumentModal: false });
        };
        /**
         * 資料表示モーダルの閲覧ログ保存
         * @type {(function())|*}
         */
        this.onChangeDocumentImage = (imageIndex, option) => {
            const { apiCreateClientSeminarDocumentPageView } = this.props;
            const { isShowDocumentModal, seminarIdDisplayedDocument } = this.state;
            const { activeColumn } = option;
            let pageViewId = null;
            let running = false;
            let interval;
            const savePageView = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (running) {
                    return;
                }
                running = true;
                try {
                    const { payload } = yield apiCreateClientSeminarDocumentPageView(seminarIdDisplayedDocument, imageIndex, pageViewId);
                    pageViewId = (_a = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _a !== void 0 ? _a : null;
                }
                finally {
                    running = false;
                }
            });
            if (isShowDocumentModal && !activeColumn) {
                savePageView().then();
                interval = setInterval(savePageView, 2000);
            }
            return () => {
                clearInterval(interval);
            };
        };
        const { auth, profile } = props;
        const isAdmin = !!profile.isAdmin;
        const isClient = isClientCheck(auth);
        this.initialPageState = {
            historyId: null,
            maxScore: 0,
            pages: {
                1: {
                    initialLoaded: false,
                    list: [],
                    loading: false,
                },
            },
            total: 0,
        };
        const tabs = getConsultantServiceTabs(isAdmin, isClient);
        const queryState = this.getQueryStateFromHistory(props, isAdmin, tabs);
        this.state = Object.assign(Object.assign(Object.assign({ 
            // フィルター表示
            isShowFilter: true, 
            // お気に入り一覧
            slideFavoriteMap: {}, 
            // タブ表示
            tabs }, queryState), { 
            // 資料モーダルに表示する画像 state
            documentModalImages: [], 
            // API実行状態（コンサルタント）
            isConsultantInitialLoaded: false, isConsultantPaging: {}, 
            // 資料モーダル表示制御
            isShowDocumentModal: false, isShowLoginModal: queryState.search === 'slide', 
            // pre会員登録用のアラートモーダル表示制御
            isShowPreAlert: false, 
            // ゲスト会員の登録完了モーダル表示制御
            isShowRegistrationCompleteModal: false, 
            // ゲスト会員の登録フォーム表示制御
            isShowRegistrationForm: true, 
            // タブコンテンツが表示されているかどうか
            isShowTabContents: false, 
            // コンサル検索用state
            professionalPaging: cloneDeep(this.initialPageState), 
            // PROFFIT SEARCH スライド検索用state
            psSlidePaging: cloneDeep(this.initialPageState), 
            // 資料モーダルに画像表示中のセミナーID
            seminarIdDisplayedDocument: null, 
            // セミナー検索用state
            seminarPaging: cloneDeep(this.initialPageState), 
            // スライド検索用state
            slidePaging: cloneDeep(this.initialPageState), 
            // プロジェクト事例検索用state
            solutionPaging: cloneDeep(this.initialPageState) }), this.loadUserState(auth, profile));
        this.isUnmount = false;
        this.apiId = null;
    }
    componentDidMount() {
        const { location } = this.props;
        const { keyword, search } = this.state;
        const { baseId, searchFrom } = parse(location.search);
        this.loadInitialData(this.props, this.state, {
            searchFrom,
        }, baseId);
        // canonical タグ更新
        this.updateCanonicalTag({ keyword, search });
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { auth, location, profile } = this.props;
        const { keyword, search } = this.state;
        let result = true;
        // canonical タグ更新
        if (keyword !== nextState.keyword || search !== nextState.search) {
            this.updateCanonicalTag({
                keyword: nextState.keyword,
                search: nextState.search,
            });
        }
        if (nextProps.history.action === 'POP' &&
            location.search !== nextProps.location.search) {
            // query stringからstate設定（ブラウザバック用）
            const isAdmin = !!nextProps.profile.isAdmin;
            const isClient = isClientCheck(nextProps.auth);
            const tabs = getConsultantServiceTabs(isAdmin, isClient);
            const updateState = this.getQueryStateFromHistory(nextProps, isAdmin, tabs);
            const newState = Object.assign({}, nextState);
            this.safeSetState(updateState);
            const { initialLoaded } = this.getViewParam(newState, search);
            if (!initialLoaded) {
                this.loadData(newState, this.getSearches()).then();
            }
            result = false;
        }
        if (auth !== nextProps.auth || profile !== nextProps.profile) {
            const currentUserState = this.loadUserState(auth, profile);
            const newUserState = this.loadUserState(nextProps.auth, nextProps.profile);
            const updateState = Object.assign({ tabs: getConsultantServiceTabs(!!nextProps.profile.isAdmin, isClientCheck(nextProps.auth)) }, newUserState);
            this.safeSetState(updateState);
            if (currentUserState.hasSlideRole === false &&
                newUserState.hasSlideRole === true &&
                nextState.search === 'slide') {
                this.loadData(Object.assign(Object.assign({}, nextState), updateState), [
                    nextState.search,
                ]).then();
            }
            result = false;
        }
        return result;
    }
    componentWillUnmount() {
        this.isUnmount = true;
    }
    render() {
        const { experiencedIndustryClasses, isLg, isMd, location, login, slideTypes, themes, updateProfile, viewSeminarThemes, } = this.props;
        const { documentModalImages, hasSlideRole, inputIndustries, inputPsSlideTypes, inputSeminarThemes, inputSlideKinds, inputSlideThemes, inputSlideTypes, isAdmin, isClient, isGuest, isPre, isProfessional, isShowDocumentModal, isShowFilter, isShowLoginModal, isShowPreAlert, isShowRegistrationCompleteModal, isShowRegistrationForm, keyword, 
        // コンサル検索用state
        order, 
        // プロジェクト事例検索用state
        professionalPaging, 
        // セミナー検索用state
        psSlideOrder, psSlideOrders, psSlidePage, 
        // スライド検索用state
        psSlidePaging, psSlideSearchType, 
        // スライド表示用state
        search, 
        // PROFFIT SEARCH スライド検索用state
        searchPage, seminarOrder, 
        // フィルター表示用state
        seminarPage, 
        // ゲスト会員の登録フォーム表示制御
        seminarPaging, 
        // ゲスト会員の登録完了モーダル表示制御
        seminarThemes, 
        // 資料モーダル表示制御
        seminarTypes, 
        // 資料モーダルに表示する画像 state
        servicePage, showSlidePage, slideFavoriteMap, slideOrder, slidePage, slidePaging, slideSearchType, solutionPaging, tabs, } = this.state;
        if (isNullOrUndefinedOrEmpty(keyword)) {
            return _jsx(CustomRedirect, { to: '/consultant' });
        }
        const { isNoResult, pageNo, total } = this.getViewParam(this.state, search);
        const totals = this.getViewTotals(this.state);
        const perPage = this.getPerPage();
        const professionalPageData = professionalPaging.pages[searchPage] || {};
        const solutionPageData = solutionPaging.pages[servicePage] || {};
        const seminarPageData = seminarPaging.pages[seminarPage] || {};
        const slidePageData = slidePaging.pages[slidePage] || {};
        const psSlidePageData = psSlidePaging.pages[psSlidePage] || {};
        const isBlur = !isClient;
        const isBlurClass = `is-blur-layout ${isSupportFilter ? '' : 'not-support-filter'}`;
        return (_jsxs(Layout, Object.assign({ headerClassName: 'header-consultant-search', headerType: 'search', mainClassName: clsx('l-main', 'layout-consultant-search', isBlur && isBlurClass, isGuest && 'is-guest-layout'), onChangeKeyword: this.onChangeKeyword, onChangeSearch: this.onChangeSearchMain, onSubmitSearch: this.onChangeKeywordSubmit }, { children: [_jsx(ConsultantSearchHeader, { isOpen: !showSlidePage, isShowFilter: isShowFilter, isTabDisable: isProfessional, onChangeSearch: this.onChangeSearch, search: search, tabs: tabs, totals: totals }), showSlidePage ? (_jsx(ConsultantSearchListBodySlideOne, { onClickCopy: this.onClickCopy, onClickSlideClip: this.onClickSlideClip, onClickSlideShow: this.onClickSlideShow, showSlidePage: showSlidePage, slideFavoriteMap: slideFavoriteMap, slidePageData: slidePageData })) : (_jsxs(_Fragment, { children: [_jsx(ConsultantSearchListBody, { currentPage: pageNo, experiencedIndustryClasses: experiencedIndustryClasses, hasSlideRole: hasSlideRole, inputIndustries: inputIndustries, inputPsSlideTypes: inputPsSlideTypes, inputSeminarThemes: inputSeminarThemes, inputSlideKinds: inputSlideKinds, inputSlideThemes: inputSlideThemes, inputSlideTypes: inputSlideTypes, isAdmin: isAdmin, isBlur: isBlur, isClient: isClient, isGuest: isGuest, isLg: isLg, isMd: isMd, isNoResult: isNoResult, isPre: isPre, isProfessional: isProfessional, isShowFilter: isShowFilter, isShowLoginModal: isShowLoginModal, isShowPreAlert: isShowPreAlert, keyword: keyword, locationSearch: location.search || '', onChangeFilter: this.onChangeFilter, onChangeInputFilter: this.onChangeInputFilter, onChangeNormalOrder: this.onChangeNormalOrder, onChangePage: this.onChangePage, onChangePsSlideOrder: this.onChangePsSlideOrder, onChangePsSlideSearchType: this.onChangePsSlideSearchType, onChangeSearch: this.onChangeSearch, onChangeSeminarOrder: this.onChangeSeminarOrder, onChangeSeminarTypes: this.onChangeSeminarTypes, onChangeSlideOrder: this.onChangeSlideOrder, onChangeSlideSearchType: this.onChangeProffitSlideSearchType, onClickExaminationAlert: this.onClickExaminationAlert, onClickForLinkEvent: this.onClickForLinkEvent, onClickLoginClose: this.onClickLoginClose, onClickPage: this.onClickPage, onClickProjectCountLink: this.onClickProjectCountLink, onClickSeminarDocumentLink: this.onClickSeminarDocumentLink, onClickSlide: this.onClickSlide, onClickSlideClip: this.onClickSlideClip, onSubmitLogin: login, order: order, perPage: perPage, professionalPageData: professionalPageData, psSlideOrder: psSlideOrder, psSlideOrders: psSlideOrders, psSlidePageData: psSlidePageData, psSlideSearchType: psSlideSearchType, scrollToRegistrationForm: this.scrollToRegistrationForm, search: search, seminarOrder: seminarOrder, seminarPageData: seminarPageData, seminarThemes: seminarThemes, seminarTypes: seminarTypes, sendPickup: this.sendPickup, slideFavoriteMap: slideFavoriteMap, slideOrder: slideOrder, slidePageData: slidePageData, slideSearchType: slideSearchType, slideTypes: slideTypes, solutionPageData: solutionPageData, themes: themes, toggleFilter: this.toggleFilter, total: total, totalCount: total, updateProfile: updateProfile, viewSeminarThemes: viewSeminarThemes }), isShowDocumentModal && search === 'seminar' && (_jsx(FullScreenImageViewerModal, { hideFullModal: this.onClickDocumentModalClose, images: documentModalImages, isShow: isShowDocumentModal, onChangeSlideImage: this.onChangeDocumentImage })), isClient && (_jsx(ConsultantSearchListFooter, { sendPickup: this.sendPickup, totalCount: total })), isGuest && (_jsxs(_Fragment, { children: [_jsx(RegistrationCta, { isShow: isShowRegistrationForm, onSubmitAfter: this.onSubmitAfterRegistration, registrationType: REGISTRATION_TYPE_CONSULTANT_SEARCH, scrollName: 'consultant_search_registration_form' }), _jsx(RegistrationCompleteModal, { hideModal: this.hideRegistrationCompleteModal, isShow: isShowRegistrationCompleteModal, timeout: 300 })] })), _jsx(SendPickupCompleteModal, {})] }))] })));
    }
}
ConsultantSearchList.propTypes = {
    apiCreateClientSeminarDocumentPageView: propFunc().isRequired,
    apiGetListConsultantSearchMulti: propFunc().isRequired,
    auth: PropTypesAuthToken.isRequired,
    createSlideClip: propFunc().isRequired,
    deleteSlideClip: propFunc().isRequired,
    experiencedIndustryClasses: propArrayShape().isRequired,
    history: propHistory(),
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    location: propLocation(),
    login: propFunc().isRequired,
    profile: propShape(),
    resetPickup: propFunc().isRequired,
    sendPickup: propFunc().isRequired,
    showNotification: propFunc().isRequired,
    showPdfModal: propFunc().isRequired,
    showSendPickupCompleteModal: propFunc().isRequired,
    slideTypes: propArrayShape().isRequired,
    themes: propArrayShape().isRequired,
    updateCanonical: propFunc().isRequired,
    updateConsultantSearchViewRequest: propFunc().isRequired,
    updateConsultantSearchViewRequestResult: propFunc().isRequired,
    updateProfile: propFunc().isRequired,
    viewSeminarThemes: propArrayShape(),
};
ConsultantSearchList.defaultProps = {
    profile: {},
    viewSeminarThemes: [],
};
const mapStateToProps = ({ auth, category, profile }) => ({
    auth,
    experiencedIndustryClasses: category.experiencedIndustryClasses,
    profile,
    slideTypes: category.slideTypes,
    themes: category.largeTasks,
    viewSeminarThemes: category.seminarCategories,
});
const mapDispatchToProps = (dispatch) => ({
    apiCreateClientSeminarDocumentPageView: (id, page, viewId, meta) => wrapDispatch(dispatch, apiCreateClientSeminarDocumentPageViewAction(id, page, viewId, meta)),
    apiGetListConsultantSearchMulti: (params) => wrapDispatch(dispatch, apiGetListConsultantSearchMultiAction(params)),
    createSlideClip: (id) => wrapDispatch(dispatch, apiCreateSlideClip(id)),
    deleteSlideClip: (id) => wrapDispatch(dispatch, apiDeleteSlideClip(id)),
    login: (values) => wrapDispatch(dispatch, apiAuthRoleSlide(values)),
    resetPickup: (formName) => dispatch(reset(formName)),
    sendPickup: (values) => new Promise((resolve, reject) => {
        const action = solutionPickup(values, {
            reject,
            resolve: ({ payload }) => resolve(payload),
        });
        dispatch(action);
    }),
    showNotification: (message) => dispatch(showNotificationAction(message)),
    showPdfModal: (images, initialSlide) => dispatch(showModal(MODAL_TYPE_PDF_VIEW_IMAGE, null, {
        images,
        initialSlide,
        pdfProp: { isObject: true, key: 'image' },
    })),
    showSendPickupCompleteModal: () => dispatch(showModalAction(MODAL_TYPE_SEND_PICKUP_COMPLETE)),
    updateCanonical: (url) => wrapDispatch(dispatch, updateCanonicalAction(url)),
    updateConsultantSearchViewRequest: (id) => wrapDispatch(dispatch, apiUpdateConsultantSearchViewRequest(id)),
    updateConsultantSearchViewRequestResult: (id, resultId, params, meta) => wrapDispatch(dispatch, apiUpdateConsultantSearchResultViewRequest(id, resultId, params, meta)),
    updateProfile: (profile) => dispatch({ payload: profile, type: API_GET_ONE_PROFILE_SUCCESS }),
});
const enhance = compose(AuthenticationHoc(), CategoryHoc('seminar_category', 'seminarCategories'), MediaQueryForConsultantSearchHoc, connect(mapStateToProps, mapDispatchToProps));
export default enhance(ConsultantSearchList);
